export default {
  id: null,
  empresaID: null,
  grupoID: null,
  funcionarioID: null,
  username: null,
  nome: null,
  telefoneCelular: null,
  email: null,
  senha: null,
  status: null,
  enviaEmail: null
}



// WEBPACK FOOTER //
// ./src/shared/models/access/accountmodel.js